import styled from "styled-components";

export const Container = styled.div`
  color: #000;
  background: #fff;
  width: 100%;
  padding: 0 0 5rem;
  .hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 85vh;
    background-repeat: no-repeat;
    position: relative;
    width: 90%;
    margin: 0 auto 1rem;
    .hero-content-container {
      width: 100%;
      h1 {
        span {
          color: #ff6a00;
        }
      }
    }
    .hero-images-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      .image {
        width: 90%;
      }
    }
  }
  .separetion-section {
    height: 100px;
    margin: 2rem 0;
    background: #ff6a00;
  }
  .t-section {
    &.pinkBackground {
      background: #fff2e9;
      border-radius: 24px;
      margin: 0 1rem;
    }
    .t-section-extra {
      width: 90%;
      margin: 1rem auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .content-container,
      img {
        width: 100%;
        margin: 1rem 0;
      }
    }
  }
  .packages-section {
    width: 90%;
    margin: 1rem auto;
    h2 {
      text-align: center;
    }
  }
  .contact-section {
    width: calc(90% - 6rem);
    margin: 3rem auto 0;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 24px;
    padding: 3rem;
    background: linear-gradient(-180deg, #414140 0%, #40403e 20%, #222221 100%);
    h2 {
      width: 100%;
    }
    div {
      width: 100%;
    }
  }
  @media only screen and (min-width: 867px) {
    .hero {
      flex-direction: row;
      .hero-content-container,
      .hero-images-container {
        width: 49%;
      }
    }
    .t-section {
      .t-section-extra {
        flex-direction: row;
        &.revesed {
          flex-direction: row-reverse;
          .image-container {
            justify-content: flex-start;
          }
        }
        .content-container {
          width: 50%;
          p {
            width: 80%;
            margin: 2rem 0;
          }
        }
        .image-container {
          width: 50%;
          display: flex;
          justify-content: flex-end;
          img {
            width: 80%;
            height: auto;
          }
        }
      }
    }
    .contact-section {
      flex-direction: row;
      h2 {
        width: 50%;
      }
      div {
        width: 50%;
      }
    }
  }
`;
